import { Button } from "components/DesignSystem/Button/Button";
import { CaretRight } from "components/icons/CaretRight";
import React, { ReactNode } from "react";

export const ChannelInfoWrapper = ({
  title,
  children,
  openDetails,
  hasDetails = true,
}: {
  title: ReactNode;
  children: ReactNode;
  openDetails: () => void;
  hasDetails?: boolean;
}) => {
  return (
    <div className="t-px-4 t-py-4 t-rounded-lg t-border t-border-solid t-border-neutral-10">
      <div
        className="t-flex t-justify-between t-items-center"
        role={hasDetails ? "button" : "none"}
        onClick={() => hasDetails && openDetails()}
      >
        <div>{title}</div>

        {hasDetails && (
          <div className="t-text-text-30">
            <CaretRight />
          </div>
        )}
      </div>
      <hr className="t-text-neutral-10 t-my-4" />
      {children}
    </div>
  );
};
